import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

if (!apiUrl) {
  console.warn("REACT_APP_API_URL não está definida. Verifique o arquivo .env");
}

export const api = axios.create({
  baseURL: apiUrl,
});
